import { createStore } from "vuex";

import user from "./modules/user";

export default createStore({
	state: {},
	getters: {
		userInfo(state) {
			return state.user.userInfo;
		},
		userId(state) {
			return state.user.userInfo.id;
		},
	},
	mutations: {},
	actions: {},
	modules: {
		user,
	},
});
